import { CHAT_LIST_FETCH_SIZE } from '~/features/chatRoom/useGetChatRoomListQuery';
import {
  GetChatRoomInfoRequest,
  GetChatRoomInfoResponse,
  GetPreviousChatRequest,
  GetPreviousChatResponse,
  SetNotificationRequest,
  SetSafeChatRequest,
  EmptyResponse,
  GetChatRoomListResponse,
  ChatEvaluationRequest,
  ChatEvaluationResponse,
  CreateChatRoomRequest,
  CreateChatRoomResponse,
  DeleteEvaluateChatRequest,
  FetchEvaluateChatRequest,
  PaginationRequest,
  SendChatReportRequest,
  UpdateMysteryChatStepRequest,
} from '~/types';
import { fetcher } from './config/fetcher';
import http from './config/http';

export const fetchPreviousChat = async ({
  chatroom_id,
  last_evaluated_key,
}: GetPreviousChatRequest) => {
  return fetcher(() =>
    http.get<GetPreviousChatResponse>(`/chatrooms/${chatroom_id}/chats`, {
      params: {
        last_evaluated_key: last_evaluated_key,
        // limit:
      },
    }),
  );
};

export const getChatroomInfo = async ({
  chatroom_id,
}: GetChatRoomInfoRequest) => {
  return fetcher(() =>
    http.get<GetChatRoomInfoResponse>(`/chatrooms/${chatroom_id}`),
  );
};

export const setNotification = async ({
  chatroom_id,
  notification,
}: SetNotificationRequest) => {
  return fetcher(() =>
    http.put<EmptyResponse>(`/chatrooms/${chatroom_id}/notifications`, {
      notification,
    }),
  );
};

export const setSafeChat = async ({
  chatroom_id,
  value,
}: SetSafeChatRequest) => {
  return fetcher(() =>
    http.put<EmptyResponse>(`/chatrooms/${chatroom_id}/safe`, {
      value,
    }),
  );
};

export const updateMysteryChatStep = async ({
  chatroom_id,
  step,
}: UpdateMysteryChatStepRequest) => {
  return fetcher(() =>
    http.put<EmptyResponse>(`/chatrooms/${chatroom_id}/mystery-steps`, {
      step,
    }),
  );
};

export const fetchEvaluateChat = async ({
  chatroom_id,
  like,
  send_time,
}: FetchEvaluateChatRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/chatrooms/${chatroom_id}/evaluations`, {
      like,
      send_time,
    }),
  );
};

export const deleteEvaluateChat = async ({
  chatroom_id,
  send_time,
}: DeleteEvaluateChatRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(`/chatrooms/${chatroom_id}/evaluations`, {
      params: {
        send_time,
      },
    }),
  );
};

export const checkEvaluation = async ({
  chatroom_id,
  send_time,
}: ChatEvaluationRequest) => {
  return fetcher(() =>
    http.get<ChatEvaluationResponse>(`/chatrooms/${chatroom_id}/evaluations`, {
      params: {
        send_time,
      },
    }),
  );
};

export const sendChatReport = async ({
  chatroom_id,
  subject,
  explanation,
}: SendChatReportRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/chatrooms/${chatroom_id}/reports`, {
      subject,
      explanation,
    }),
  );
};

export const fetchChatRoomList = async ({ page }: PaginationRequest<void>) => {
  return fetcher(() =>
    http.get<GetChatRoomListResponse>(`/chatrooms`, {
      params: { page, page_size: CHAT_LIST_FETCH_SIZE },
    }),
  );
};

export const createChatRoom = async ({
  language,
  character_id,
}: CreateChatRoomRequest) => {
  return fetcher(() =>
    http.post<CreateChatRoomResponse>('/chatrooms', {
      language,
      character_id,
    }),
  );
};
